import * as React from "react";
import { FeedItemLike } from "../../../server/feed/buildfeed";
import { FeedElementContainer } from "../DesignSystem/formatting/FeedComponents";
import { LinkToUser } from "../DesignSystem/LinkToUser";
import { RLink } from "../DesignSystem/RLink";

export const FeedElementLike = ({ item }: { item: FeedItemLike }) => {
  return (
    <FeedElementContainer
      href={`/entry/${item.like.entry_id}`}
      compact
      avatars={[
        { username: item.liking_username, avatar_url: item.avatar_url },
      ]}
      icon={"heart"}
      title={
        <>
          <LinkToUser linkUser={{ username: item.liking_username }} />
          <span className="text-slate-500 dark:text-slate-400"> liked </span>
          <RLink white to={"/entry/" + item.like.entry_id}>{item.title}</RLink>
        </>
      }
    ></FeedElementContainer>
  );
};
